<template>
  <div class="p-accommodationCarousel">
    <div class="p-accommodationCarousel__container">
      <slick
        ref="slick"
        :options="slickOptions">
        
        <div class="p-accommodationCarousel__item" v-for="item in items">
          <figure>
            <img :src="item.image.url" alt="">
            <figcaption v-if="item.caption">{{ item.caption }}</figcaption>
          </figure>
        </div>
      </slick>
    </div>
  </div>
</template>

<script>
  import Slick from 'vue-slick';

  const ITEM_PER_PAGE = 4

  export default {
    name: 'accommodation-carousel',
    components: {
      Slick
    },
    props: {
      gallery: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        items: [],
        slickOptions: {
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          slidesToShow: ITEM_PER_PAGE,
          speed: 1200,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '44px',
              }
            },
          ]
        }
      }
    },
    watch: {
    },
    created() {
      // 画像枚数が slidesToShow と同じ場合、カルーセルとして機能せず最後の一枚が見切れてしまう
      // 配列を連結して八枚の画像としてカルーセルを動作させる
      this.items = this.gallery.length === ITEM_PER_PAGE ? this.gallery.concat(this.gallery) : this.gallery
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
      
    }
  };
</script>


// WEBPACK FOOTER //
// src/partial/accommodation-carousel.vue